
import React from 'react';
import { updateEstadoGrupoPlanes } from '../../api/axios';
import { toast } from 'react-toastify';

export default class PlanesListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      estado: props.estado
    };
  }

  handleSwitchChange = async (e) => {
  const { idGrupo, filtro, onEstadoActualizado } = this.props;
    const nuevoEstado = this.state.estado === 0 ? 2 : 0;
    try {
      const response = await updateEstadoGrupoPlanes({ id: idGrupo, estado: nuevoEstado });
      const mensaje = response?.data?.mensaje || 'Estado actualizado';
      this.setState({ estado: nuevoEstado }, () => {
        toast.success(mensaje);
        // Si hay filtro de estado, refrescar la lista llamando al callback del padre
        if (filtro && typeof filtro.estado === 'number' && typeof onEstadoActualizado === 'function') {
          onEstadoActualizado();
        }
      });
    } catch (err) {
      toast.warn('Error al actualizar el estado');
    }
  };

  render = () => {
    const { idGrupo, nombre, comision, cantidadPlanes } = this.props;
    const { estado } = this.state;
    const isActivo = estado === 0;

    return (
      <div className="list-group-item hover-background-color">
        <div className="row justify-content-between align-items-center">
          <div className="col-2 col-md-1">
            <h6 className="box-title font-weight-bold text-center">{idGrupo}</h6>
          </div>
          <div className="col-8 col-md-6 text-break">
            <small className="font-14 applyFont">{nombre}</small>
          </div>
          <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
            <small className="font-14 applyFont">
              {cantidadPlanes} <span className="ms-1">Planes</span>
            </small>
          </div>
          <div className="col-2 col-md-1 d-flex justify-content-end align-items-center">
            <small className="font-14 applyFont">{comision}</small>
            <i className="fas fa-percent mx-1" />
          </div>
          <div className="col-2 col-md-1 d-flex justify-content-start align-items-center">
            <div className="custom-control form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isActivo}
                onChange={this.handleSwitchChange}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
}
